// Deposel (Webpostman) REST API sağlayıcısı.
// Döküman: YET REKLAM.pdf — Deposel, FEST ile AYNI Webpostman altyapısını kullanır. Endpoint'ler,
// kimlik doğrulama (Authorization + From header), form-urlencoded gövde, statü kodları (00-60) ve
// durum kovaları (0-6) birebir aynıdır. Tek fark taban URL'dir; kargo firması/şube kodları cari
// başına UI'dan girilir (veri farkı, kod farkı değil).
import { createWebpostmanProvider } from './webpostman'

const DEPOSEL_BASE = 'https://webpostman.deposerileti.com/restapi/client'

export const deposelProvider = createWebpostmanProvider('deposel', DEPOSEL_BASE)
